import React, { type FC } from 'react'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  Flex,
  LINK_VARIANT_EXTRALIGHT,
  Link,
  SKELETON_LOADER_VARIANT_ONWHITE,
  SkeletonLoader,
  TruncateAndTooltip,
} from 'mailup-web-components'

import RenderWhen from 'Components/RenderWhen'

import { modalRecipientGroupsOpenCallback } from 'Pages/RecipientsList/recoil/callbacks/modalRecipientGroups'
import {
  recipientGroupsInListState,
  recipientsGroupsState,
} from 'Pages/RecipientsList/recoil/state/groups'

interface GroupsViewProps {
  id: number
}

const GroupsView: FC<GroupsViewProps> = ({ id }) => {
  const intl = useIntl()

  const { status } = useRecoilValue(recipientsGroupsState)
  const recipientGroups = useRecoilValue(recipientGroupsInListState(id))

  const openModal = useRecoilCallback(modalRecipientGroupsOpenCallback, [])

  const handleMoreGroups = (): void => {
    void openModal(id)
  }

  return (
    <Flex flexDirection="column" gap="8px">
      <RenderWhen condition={status !== 'ready'}>
        <SkeletonLoader variant={SKELETON_LOADER_VARIANT_ONWHITE} />
      </RenderWhen>
      <RenderWhen condition={status === 'ready'}>
        <div style={{ maxWidth: '200px' }}>
          {recipientGroups.items.map((rg) => (
            <TruncateAndTooltip
              key={`${id}_${rg.Id}`}
              text={`${rg.Id} - ${rg.Name} `}
            />
          ))}
        </div>

        <RenderWhen condition={recipientGroups.items.length === 0}>
          -
        </RenderWhen>

        <RenderWhen condition={recipientGroups.moreItems}>
          <Link
            variant={LINK_VARIANT_EXTRALIGHT}
            onClick={handleMoreGroups}
            data-mu-test="recipient-more-groups"
          >
            {intl.formatMessage({ id: 'Load.RecipientsList.MoreGroups' })}
          </Link>
        </RenderWhen>
      </RenderWhen>
    </Flex>
  )
}

export default GroupsView
